import { render } from "./Navigation.vue?vue&type=template&id=275102c0"
const script = {}
script.render = render

export default script